<script lang="ts" setup>
import type { Category } from '~~/server/api/documents/index'
import type { Data } from '~~/server/api/documents/index'

export interface PagesDocumentsChildrenProps {
    data: Data
}
export interface PagesDocumentsChildrenEmitsValue {
    value: string
    key: string
}
export interface PagesDocumentsChildrenEmits {
    (e: 'click', value: PagesDocumentsChildrenEmitsValue): void
}

const props = defineProps<PagesDocumentsChildrenProps>()
const { $t } = useNuxtApp()
const emit = defineEmits<PagesDocumentsChildrenEmits>()

const title = $t('Podkategória:')

const subcategoryGroupTitleId = useId()

const subcategory = computed<Category | undefined>((): Category | undefined =>
    props.data.categories.find(
        (category): boolean =>
            category.slug === props.data.category_level_1?.slug
    )
)
</script>
<template>
  <section
    v-if="
      subcategory &&
        subcategory.children &&
        subcategory.children?.length > 0
    "
    data-cy="pages_documents_children"
    class="mb-4 mb-md-6"
    :aria-labelledby="subcategoryGroupTitleId"
  >
    <Tracker :data="{ position: title }">
      <p
        :id="subcategoryGroupTitleId"
        class="zeta mb-2 mb-md-4 fw-bold"
      >
        {{ title }}
      </p>
      <ul
        class="d-flex gap-2 flex-wrap"
        role="list"
        :aria-label="$t('Filtrovať podľa podkategórie')"
      >
        <li
          v-for="(child, index) in subcategory.children"
          :key="`dsubsc-${index}`"
          class="flex-shrink-0"
        >
          <VButton
            color="tertiary"
            :class="{
              'is-active':
                props.data.category_level_2?.slug ===
                child.slug,
            }"
            :aria-pressed="props.data.category_level_2?.slug === child.slug"
            type="button"
            :label="child.title"
            @click.prevent="
              emit('click', {
                value: child.slug,
                key: 'p',
              })
            "
          >
            {{ child.title }}
          </VButton>
        </li>
      </ul>
    </Tracker>
  </section>
</template>
